export default {
  computed: {
    dataBarSet() {
      if (this.data.items) {
        return {
          labels: this.getLabels(),
          datasets:[
            {
              backgroundColor: this.getBackground(),
              hoverBackgroundColor: this.getBackground(),
              data: this.getDataSets(),
              showLabel: this.showLabel,
            }]
        };
      }

      return {};
    }
  },
  methods: {
    getBackground() {
      let entries = this.data.items;
      return ['#15CF49', '#5E6D82', '#E42E2E'];
    },
    getDataSets() {
      let entries = this.data.items.filter(it => it.thematic_id != 0) || [];
      let positive = entries.reduce((sum, current) => Number(current.count) > 0 ? sum + Number(current.trust.positive) : sum, 0);
      let netural = entries.reduce((sum, current) => Number(current.count) > 0 ? sum + Number(current.trust.netural) : sum, 0);
      let negative = entries.reduce((sum, current) => Number(current.count) > 0 ? sum + Number(current.trust.negative) : sum, 0);

      let summ = Number(positive) + Number(netural) + Number(negative)
      //Math.round(Number(item.count) / this.data.count * 100)
      let positivePr = positive/summ

      return [Math.round(Number(positive) / summ * 100), Math.round(Number(netural) / summ * 100), Math.round(Number(negative) / summ * 100)]
    },
    getLabels() {
      const keys = Object.keys(this.data.items);
      let labels = ["Позитивные", "Нейтральные", "Негативные"]
      return labels
    }
  },
  data() {
    return {
      endTime: '23:59:59',
      lineOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 9,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: (value) => {
              if (value === 0) {
                return "";
              }

              return value + '%';
            },
            anchor: "center",
            color: "#ffffff",
            font: {
              weight: "normal",
              size: 14,
              family: "Roboto"
            },
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
